if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.mobileMq = window.matchMedia('(max-width: 749px)');
      this.content = this.querySelector('.product-media-modal__content');
      this.prevButton = this.querySelector('[data-product-modal-prev]');
      this.nextButton = this.querySelector('[data-product-modal-next]');
      this.currentCounter = this.querySelector('[data-product-modal-current]');
      this.totalCounter = this.querySelector('[data-product-modal-total]');
      this.hint = this.querySelector('[data-product-modal-hint]');
      this.zoomStates = new WeakMap();
      this.hintTimeout = null;

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.changeMedia(-1));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.changeMedia(1));
      }

      this.onViewportChange = this.onViewportChange.bind(this);

      if (this.mobileMq.addEventListener) {
        this.mobileMq.addEventListener('change', this.onViewportChange);
      } else if (this.mobileMq.addListener) {
        this.mobileMq.addListener(this.onViewportChange);
      }
    }

    hide() {
      this.clearHintTimer();
      this.setHintVisibility(false, true);
      this.resetAllZoom(true);
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.initInspectionMode();
    }

    onViewportChange() {
      if (!this.hasAttribute('open')) return;
      this.initInspectionMode();
    }

    showActiveMedia() {
      const currentMediaId = this.openedBy && this.openedBy.getAttribute('data-media-id');
      if (!currentMediaId) return;

      this.getAllMediaItems().forEach((element) => {
        if (element.getAttribute('data-media-id') !== currentMediaId) {
          element.classList.remove('active');
        }
      });

      const activeMedia = this.querySelector(`[data-media-id="${currentMediaId}"]`);
      if (!activeMedia) return;

  
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });

      const container = this.querySelector('[role="document"]');
      if (container && !this.mobileMq.matches) {
        container.scrollLeft = Math.max(0, (activeMedia.clientWidth - container.clientWidth) / 2);
      }

this.playMediaForItem(activeMedia);

      this.updateMobileControls();
    }

    refreshMedia() {
      const visibleItems = this.getVisibleMediaItems();
      if (!visibleItems.length) return;

      const activeVisibleItem = visibleItems.find((item) => item.classList.contains('active'));
      const nextActiveItem = activeVisibleItem || visibleItems[0];

      this.getAllMediaItems().forEach((item) => {
        item.classList.toggle('active', item === nextActiveItem);
      });

      this.updateMobileControls();
    }

    initInspectionMode() {
      this.bindImageStages();
      this.refreshMedia();

      if (this.mobileMq.matches) {
        this.showHintTemporarily();
      } else {
        this.clearHintTimer();
        this.setHintVisibility(false, true);
        this.resetAllZoom(true);
      }
    }

    getAllMediaItems() {
      if (!this.content) return [];
      return Array.from(this.content.children).filter((item) => item.hasAttribute('data-media-id'));
    }

    getVisibleMediaItems() {
      return this.getAllMediaItems().filter((item) => !item.hidden && item.style.display !== 'none');
    }

    getActiveMediaItem() {
      const visibleItems = this.getVisibleMediaItems();
      return visibleItems.find((item) => item.classList.contains('active')) || visibleItems[0] || null;
    }

    setActiveMediaItem(targetItem) {
      if (!targetItem) return;

      this.getAllMediaItems().forEach((item) => {
        item.classList.toggle('active', item === targetItem);
      });

      targetItem.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      this.resetAllZoom(false);
      this.playMediaForItem(targetItem);
      this.updateMobileControls();
    }

    playMediaForItem(item) {
      window.pauseAllMedia();

      const deferredMedia = item.matches('deferred-media') ? item : item.querySelector('deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    changeMedia(step) {
      if (!this.mobileMq.matches) return;

      const visibleItems = this.getVisibleMediaItems();
      if (visibleItems.length <= 1) return;

      const currentItem = this.getActiveMediaItem();
      const currentIndex = visibleItems.indexOf(currentItem);
      const targetIndex = currentIndex + step;

      if (targetIndex < 0 || targetIndex >= visibleItems.length) return;

      this.setHintVisibility(false);
      this.setActiveMediaItem(visibleItems[targetIndex]);
    }

    updateMobileControls() {
      const visibleItems = this.getVisibleMediaItems();
      const activeItem = this.getActiveMediaItem();
      const currentIndex = visibleItems.indexOf(activeItem);
      const total = visibleItems.length || 1;
      const current = currentIndex >= 0 ? currentIndex + 1 : 1;

      if (this.currentCounter) this.currentCounter.textContent = String(current);
      if (this.totalCounter) this.totalCounter.textContent = String(total);

      const controlsDisabled = !this.mobileMq.matches || total <= 1;
      if (this.prevButton) {
        this.prevButton.disabled = controlsDisabled || current <= 1;
      }
      if (this.nextButton) {
        this.nextButton.disabled = controlsDisabled || current >= total;
      }
    }

    bindImageStages() {
      this.querySelectorAll('[data-image-stage]').forEach((stage) => {
        if (stage.dataset.inspectionBound === 'true') return;
        stage.dataset.inspectionBound = 'true';

        const image = this.getStageImage(stage);
        if (!image) return;

        this.zoomStates.set(stage, this.createDefaultState());

        stage.addEventListener('touchstart', (event) => this.onStageTouchStart(event, stage), { passive: false });
        stage.addEventListener('touchmove', (event) => this.onStageTouchMove(event, stage), { passive: false });
        stage.addEventListener('touchend', (event) => this.onStageTouchEnd(event, stage), { passive: false });
        stage.addEventListener('touchcancel', (event) => this.onStageTouchCancel(event, stage), { passive: false });
        image.addEventListener('dragstart', (event) => event.preventDefault());
        image.addEventListener('load', () => this.resetStage(stage, true));
      });
    }

    createDefaultState() {
      return {
        scale: 1,
        x: 0,
        y: 0,
        panStartX: 0,
        panStartY: 0,
        touchStartX: 0,
        touchStartY: 0,
        touchMoved: false,
        isPanning: false,
        isPinching: false,
        lastTapTime: 0,
        prevPinchDistance: 0,
        prevMidpoint: null,
      };
    }

    getStageState(stage) {
      if (!this.zoomStates.has(stage)) {
        this.zoomStates.set(stage, this.createDefaultState());
      }

      return this.zoomStates.get(stage);
    }

    getStageImage(stage) {
      return stage.querySelector('[data-modal-image]');
    }

    isInteractiveStage(stage) {
      return this.mobileMq.matches && this.hasAttribute('open') && stage.closest('[data-media-id]') === this.getActiveMediaItem();
    }

    onStageTouchStart(event, stage) {
      if (!this.isInteractiveStage(stage)) return;

      const state = this.getStageState(stage);

      if (event.touches.length === 2) {
        event.preventDefault();
        state.isPinching = true;
        state.isPanning = false;
        state.touchMoved = true;
        state.prevPinchDistance = this.getTouchDistance(event.touches);
        state.prevMidpoint = this.getTouchMidpoint(event.touches);
        this.setHintVisibility(false);
        return;
      }

      if (event.touches.length !== 1) return;

      const touch = event.touches[0];
      state.touchStartX = touch.clientX;
      state.touchStartY = touch.clientY;
      state.touchMoved = false;

      if (state.scale > 1.01) {
        event.preventDefault();
        state.isPanning = true;
        state.panStartX = touch.clientX - state.x;
        state.panStartY = touch.clientY - state.y;
        this.setHintVisibility(false);
      }
    }

    onStageTouchMove(event, stage) {
      if (!this.isInteractiveStage(stage)) return;

      const state = this.getStageState(stage);

      if (event.touches.length === 2) {
        event.preventDefault();
        const currentDistance = this.getTouchDistance(event.touches);
        const currentMidpoint = this.getTouchMidpoint(event.touches);
        const nextScale = this.clamp(state.scale * (currentDistance / Math.max(state.prevPinchDistance || currentDistance, 1)), 1, 3);
        const rect = stage.getBoundingClientRect();

        if (state.prevMidpoint) {
          const previousRelativeX = state.prevMidpoint.x - rect.left - rect.width / 2;
          const previousRelativeY = state.prevMidpoint.y - rect.top - rect.height / 2;
          const currentRelativeX = currentMidpoint.x - rect.left - rect.width / 2;
          const currentRelativeY = currentMidpoint.y - rect.top - rect.height / 2;
          const ratio = nextScale / state.scale;

          state.x = currentRelativeX - (previousRelativeX - state.x) * ratio;
          state.y = currentRelativeY - (previousRelativeY - state.y) * ratio;
        }

        state.scale = nextScale;
        state.prevPinchDistance = currentDistance;
        state.prevMidpoint = currentMidpoint;
        this.applyStageTransform(stage, false);
        return;
      }

      if (event.touches.length !== 1) return;

      const touch = event.touches[0];
      const deltaX = touch.clientX - state.touchStartX;
      const deltaY = touch.clientY - state.touchStartY;

      if (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8) {
        state.touchMoved = true;
      }

      if (state.scale > 1.01 && state.isPanning) {
        event.preventDefault();
        state.x = touch.clientX - state.panStartX;
        state.y = touch.clientY - state.panStartY;
        this.applyStageTransform(stage, false);
        return;
      }

      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 12) {
        event.preventDefault();
      }
    }

    onStageTouchEnd(event, stage) {
      if (!this.mobileMq.matches) return;

      const state = this.getStageState(stage);

      if (event.touches.length === 1 && state.scale > 1.01) {
        const touch = event.touches[0];
        state.isPinching = false;
        state.isPanning = true;
        state.panStartX = touch.clientX - state.x;
        state.panStartY = touch.clientY - state.y;
        return;
      }

      if (state.isPinching) {
        state.isPinching = false;
        state.prevPinchDistance = 0;
        state.prevMidpoint = null;

        if (state.scale <= 1.01) {
          this.resetStage(stage, false);
        } else {
          this.applyStageTransform(stage, true);
        }
        return;
      }

      if (!event.changedTouches.length) return;

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - state.touchStartX;
      const deltaY = touch.clientY - state.touchStartY;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);

      if (state.scale > 1.01) {
        state.isPanning = false;
        this.applyStageTransform(stage, true);
        return;
      }

      if (absX < 12 && absY < 12 && !state.touchMoved) {
        const now = Date.now();
        if (now - state.lastTapTime < 280) {
          event.preventDefault();
          state.lastTapTime = 0;
          this.toggleStageZoom(stage, touch.clientX, touch.clientY);
          return;
        }

        state.lastTapTime = now;
        return;
      }

      if (absX > 60 && absX > absY) {
        event.preventDefault();
        this.changeMedia(deltaX < 0 ? 1 : -1);
      }
    }

    onStageTouchCancel(event, stage) {
      const state = this.getStageState(stage);
      state.isPanning = false;
      state.isPinching = false;
      state.prevPinchDistance = 0;
      state.prevMidpoint = null;

      if (state.scale <= 1.01) {
        this.resetStage(stage, false);
      } else {
        this.applyStageTransform(stage, true);
      }
    }

    toggleStageZoom(stage, clientX, clientY) {
      const state = this.getStageState(stage);
      const targetScale = state.scale > 1.01 ? 1 : 2.5;

      if (targetScale === 1) {
        state.scale = 1;
        state.x = 0;
        state.y = 0;
      } else {
        const rect = stage.getBoundingClientRect();
        const relativeX = clientX - rect.left - rect.width / 2;
        const relativeY = clientY - rect.top - rect.height / 2;
        state.scale = targetScale;
        state.x = -relativeX * (targetScale - 1);
        state.y = -relativeY * (targetScale - 1);
      }

      this.setHintVisibility(false);
      this.applyStageTransform(stage, true);
    }

    applyStageTransform(stage, animate) {
      const image = this.getStageImage(stage);
      if (!image) return;

      const state = this.getStageState(stage);
      this.clampStagePosition(stage);
      image.style.transition = animate ? 'transform 220ms ease' : 'none';
      image.style.transform = `translate3d(${state.x}px, ${state.y}px, 0) scale(${state.scale})`;
      stage.classList.toggle('is-zoomed', state.scale > 1.01);
    }

    clampStagePosition(stage) {
      const image = this.getStageImage(stage);
      if (!image) return;

      const state = this.getStageState(stage);
      if (state.scale <= 1.01) {
        state.scale = 1;
        state.x = 0;
        state.y = 0;
        return;
      }

      const maxX = Math.max(0, (image.clientWidth * state.scale - stage.clientWidth) / 2);
      const maxY = Math.max(0, (image.clientHeight * state.scale - stage.clientHeight) / 2);

      state.x = this.clamp(state.x, -maxX, maxX);
      state.y = this.clamp(state.y, -maxY, maxY);
    }

    resetStage(stage, silent) {
      const state = this.getStageState(stage);
      state.scale = 1;
      state.x = 0;
      state.y = 0;
      state.isPanning = false;
      state.isPinching = false;
      state.prevPinchDistance = 0;
      state.prevMidpoint = null;
      this.applyStageTransform(stage, !silent);
    }

    resetAllZoom(silent) {
      this.querySelectorAll('[data-image-stage]').forEach((stage) => {
        this.resetStage(stage, silent);
      });
    }

    getTouchDistance(touches) {
      const [firstTouch, secondTouch] = touches;
      return Math.hypot(secondTouch.clientX - firstTouch.clientX, secondTouch.clientY - firstTouch.clientY);
    }

    getTouchMidpoint(touches) {
      const [firstTouch, secondTouch] = touches;
      return {
        x: (firstTouch.clientX + secondTouch.clientX) / 2,
        y: (firstTouch.clientY + secondTouch.clientY) / 2,
      };
    }

    showHintTemporarily() {
      if (!this.hint || !this.mobileMq.matches) return;
      this.clearHintTimer();
      this.setHintVisibility(true, true);
      this.hintTimeout = window.setTimeout(() => {
        this.setHintVisibility(false);
      }, 2200);
    }

    clearHintTimer() {
      if (!this.hintTimeout) return;
      window.clearTimeout(this.hintTimeout);
      this.hintTimeout = null;
    }

    setHintVisibility(visible, immediate = false) {
      if (!this.hint) return;
      if (immediate) {
        this.hint.style.transition = 'none';
      } else {
        this.hint.style.transition = '';
      }
      this.hint.classList.toggle('is-hidden', !visible);
      if (immediate) {
        requestAnimationFrame(() => {
          this.hint.style.transition = '';
        });
      }
    }

    clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }
  });
}